export default "<div style=\"height: 500px\" #appraisalMapViewNode></div>\r\n";